<template>
<section class="steps">
  <div class="container">
    <div class="steps-top">
      <h2>6 этапов от заявки до сдачи проекта</h2>
    </div>
    <div class="steps-middle">
      <div class="row">
        <SectionStepsItem
            v-for="item in stepsList"
            v-bind:item = "item"
        />
      </div>
    </div>
    <div class="steps-bottom">
      <button class="button__transparent button_small" @click="openQuiz ()">Начать</button>
    </div>
  </div>
</section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SectionStepsItem from "@/components/SectionStepsItem";
export default {
  name: 'SectionSteps',
  components: {
    SectionStepsItem,
  },
  methods: {
    ...mapActions(['plusQuiz']),
    openQuiz () {
      this.plusQuiz()
    }
  },
  computed: {
    ...mapGetters ([ 'stepsList' ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.steps {
  background-color: #eee;
  padding: 45px 0;
  @media (max-width: 575.98px) {
    padding: 20px 0;
  }
  &-top {
    h2 {
      max-width: 700px;
    }
  }
  &-middle {
    margin-top: 20px;
    .row {
      display: flex;
      padding-top: 20px;
      flex-wrap: wrap;
    }
  }
  &-bottom {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
